<template>
  <div>
    <div v-if="tourneeAffichage" :key="index"
         class="height-90 border-color-select border-bottom-horizontal-none">
      <div class="columns mg-auto">
        <div class="column is-narrow pdl-0">
          <a class="card-header-icon is-cursor-pointer"
             @click="$emit('updateAfficheurSelect', afficheurId, tourneeDate,
             tourneeAffichage.tourneeId, tourneeAffichage.tournee,
              tourneeAffichage.ordreTravailId)">
            <b-icon :icon="isIconSelect && afficheurSelect.tourneeId === tourneeAffichage.tourneeId
            ? 'check-circle' : 'checkbox-blank-circle-outline'"
                    :type="isIconSelect && afficheurSelect.tourneeId === tourneeAffichage.tourneeId
                    ? 'is-primary' : ''">
            </b-icon>
          </a>
        </div>
        <div class="colum is-8 columns is-multiline is-marginless pd-10px">
          <div class=" has-text-weight-bold ellipsis has-text-link
           column is-3 is-paddingless">
           {{ tourneeDate | formatDate }}
          </div>
          <div class="has-text-weight-bold ellipsis has-text-link
            column is-7 is-paddingless">
            {{ tourneeAffichage.tournee }}
          </div>
          <div class="column is-3 is-paddingless">
            {{ tourneeAffichage.libelleJourDepart }}
          </div>
          <div class="is-size-7 has-text-default column is-7 is-paddingless">
            {{ $t('chargeTravailAff.ressourceAndAffectationInfo.nbFaces',
            { faces: tourneeAffichage.nbFaces }) }}
          </div>
          <div class="column is-8 columns is-marginless is-multiline pdl-0 pdt-5px">
            <div v-if="tourneeAffichage.ordreTravailId" class="column is-12 is-paddingless">
              <router-link-blank :to="{ name: 'c.logistique.ordre_travail-affichage',
                params: { id: tourneeAffichage.ordreTravailId } }"
                :message="tourneeAffichage.ordreTravail.code" class="lien">
              </router-link-blank>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    tourneeAffichage: {
      required: true,
      type: Object,
    },
    index: {
      required: true,
      type: Number,
    },
    isIconSelect: {
      type: Boolean,
      required: true,
    },
    afficheurSelect: {
      type: Object,
      required: true,
    },
    afficheurId: {
      type: String,
      required: true,
    },
    tourneeDate: {
      type: String,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
};

</script>
